import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";
import textUtils from "@mnjsplatform/data/lib/utils/textUtils";
import {HorizontalBar} from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';
import i18next from "i18next";

class WorkingHours extends Component {
    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.listSubForPO.reset());
            await this.props.dispatch(this.props.listSubForPO.execute({}, {withParams: true}));

            await this.refreshChartData();
        }
        catch (e) {
            console.error(e);
        }
    }

    refreshChartData = async(personList) => {
        if (!personList) {
            personList = this.getTabNums(this.props.listSubForPO, this.props.listSubForPOParams);
        }

        await this.props.dispatch(this.props.chartData.execute({PersonList: personList}, {withParams: true}));
    };

    getTabNums = (list, listParams) => {
        if (list.rowsCount() > 0) {
            let tabNumArr = list.dataTable().map(e => e.TabNum);
            if (this.includeChiefHours(list, listParams)) {
                let tabNum = listParams.getField(0, "TabNum");
                if (!tabNumArr.some(tn => tn === tabNum)) {
                    tabNumArr.push(tabNum);
                }
            }

            return tabNumArr.sort().join(";");
        }
        return "";
    };

    includeChiefHours = (list, listParams) => {
        if (listParams.isInitialized) {
            let params = listParams.getRow(0);
            if (params.IsDekret === 2) {
                return false;
            }
            if (params.AdmStructCode) {
                return false;
            }
            if (list.rawData.Filter) {
                return false;
            }
            if (list.rowsCount() === 0) {
                return false;
            }

            return true;
        }
    };

    getChartData = () => {
        if (!this.props.chartData.isInitialized) {
            return {message: i18next.t("DataLoading")};
        }

        let dt = this.props.chartData.dataTable();
        if (dt.length === 0) {
            return {message: i18next.t("DataNotFound")};
        }

        dt.sort((p1, p2) => {
            if(p1.CDivId > p2.CDivId) return 1;
            if(p1.CDivId < p2.CDivId) return -1;
            return 0;
        });

        let startPoint = dt.filter(e => e.CDivId === "R01");
        if (startPoint.length === 0){
            return {message: i18next.t("WorkingHours_PaidHoursNotFound")};
        }
        startPoint = startPoint[0];

        let initValue = startPoint.ResultValue;

        let deltaDataset = dt.map(point => {
            initValue = initValue - point.ResultValue;
            let resultPoint;
            if (point.CDivId === "R01" || point.CDivId === "R06" || point.CDivId === "R12"){
                resultPoint = { CDivName: point.CDivName, CDivId: point.CDivId, ResultValue: 0 };
                initValue = point.ResultValue;
            }
            else {
                resultPoint = { CDivName: point.CDivName, CDivId: point.CDivId, ResultValue: initValue };
            }

            return resultPoint;
        });

        return {
            data: {
                labels: deltaDataset.map(point => {
                    let result = [];
                    let words = point.CDivName.split(' ');
                    for (let i = 0; i < words.length;) {
                        let row = '';
                        do {
                            row += words[i] + ' ';
                            i = i + 1;
                        }
                        while (row.length < 17 && i < words.length);
                        result.push(row);
                    }
                    return result;
                }),
                datasets: [
                    {
                        label: i18next.t("Deltas"),
                        data: deltaDataset.map(point => point.ResultValue),
                        backgroundColor: 'transparent'
                    },
                    {
                        label: i18next.t("WorkingHours_PaidHours"),
                        data: dt.map(point => point.ResultValue),
                        backgroundColor: dt.map(point => {
                            switch (point.CDivId) {
                                case "R01":
                                    return 'rgb(120, 28, 129)';
                                case "R02":
                                    return 'rgb(0, 255, 255)';
                                case "R03":
                                    return 'rgb(70, 41, 135)';
                                case "R04":
                                    return 'rgb(217, 33, 32)';//больничный
                                case "R05":
                                    return 'rgb(51, 34, 136)';
                                case "R06":
                                    return 'rgb(72, 139, 194)';
                                case "R07":
                                    return 'rgb(231, 126, 49)';
                                case "R08":
                                    return 'rgb(210, 179, 63)';
                                case "R09":
                                    return 'rgb(185, 189, 74)';
                                case "R10":
                                    return 'rgb(231, 126, 49)';
                                case "R11":
                                    return 'rgb(149, 184, 94)';
                                case "R12":
                                    return 'rgb(107, 178, 140)';
                                default:
                                    return 'transparent';
                            }
                        })
                    }
                ]
            }
        };
    };

    renderChartParams = (h) => {
        return (
            <>
                <div className="row mb-2">
                    <div className="col-md-2">
                        {h.lbl("DateEnd")}
                    </div>
                    <div className="col-md-2">
                        {h.ed("DateEnd")}
                    </div>
                    <div className="col-md-3">
                        {h.lbl("IsCumulativeSum")}
                    </div>
                    <div className="col-md-1">
                        {h.ed("IsCumulativeSum")}
                    </div>
                </div>
            </>
        );
    };

    renderParams = (h) => {
        return (
            <>
                <div className="row mb-2">
                    <div className="col-md-6">
                        {h.ed("IsDekretMsg")}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-4">
                        {/*Количество уровней подчиненности (<span style={{color: "red"}}>не более 5 уровней</span>):*/}
                        {h.lbl("NumSub")}
                    </div>
                    <div className="col-md-1">
                        {h.ed("NumSub")}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-12">
                        {h.ed("AdmStructName")}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-4">
                        {i18next.t("SubordinateSearch")}:
                    </div>
                    <div className="col-md-8" style={{height: "32px"}}>
                        <SearchBar dataItem={this.props.listSubForPO} />
                    </div>
                </div>
            </>
        );
    };

    afterApplyFilter = () => {
        this.refreshChartData();
    };

    renderFilter = () => {
        if (!this.props.chartData.isInitialized) {
            return <div>{i18next.t("DataLoading")}</div>;
        }

        return (
            <>
                <ComplexParam dataItem={this.props.chartDataParams}
                              readOnly={false}
                              showSearchBar={false}
                              showApplyButton={false}
                              autoApplyParams={true}
                              rootPath="/"
                              parentDataItem={this.props.chartData}
                              renderParams={this.renderChartParams}
                />

                <ComplexParam dataItem={this.props.listSubForPOParams}
                              readOnly={false}
                              showSearchBar={false}
                              showApplyButton={false}
                              autoApplyParams={true}
                              rootPath="/"
                              parentDataItem={this.props.listSubForPO}
                              renderParams={this.renderParams}
                              afterApplyParams={this.afterApplyFilter}
                />
            </>
        );
    };

    renderChart = () => {
        let chartData = this.getChartData();
        /*if (this.props.chartData.isInitialized) {
            chartData = {
                data: {
                    labels: ['A', 'B', 'C'],
                    datasets: [
                        {
                            label: 'Temp dataset',
                            backgroundColor: 'rgba(255,99,132,0.2)',
                            borderColor: 'rgba(255,99,132,1)',
                            hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                            hoverBorderColor: 'rgba(255,99,132,1)',
                            data: [1, 2, 3]
                        }
                    ]
                }
            };
        }*/

        if (chartData.data) {
            let includeChiefHoursText = this.includeChiefHours(this.props.listSubForPO, this.props.listSubForPOParams)
                ? i18next.t("WorkingHours_1")
                : "";

            return (
                <>
                    {
                        includeChiefHoursText &&
                        <div><i>{includeChiefHoursText}</i></div>
                    }
                    <HorizontalBar data={chartData.data}
                                   options={{
                                       elements: {
                                           rectangle: {
                                               borderWidth: 1
                                           }
                                       },
                                       layout: {padding: {left: 0, right: 50, top: 0, bottom: 0}},
                                       responsive: true,
                                       maintainAspectRatio: true,
                                       scales: {
                                           yAxes: [{
                                               gridLines: {offsetGridLines: true, drawTicks: true},
                                               stacked: true
                                           }],
                                           xAxes: [{type: 'linear', position: 'top', stacked: true}]
                                       },
                                       plugins: {
                                           datalabels: {
                                               anchor: "end",
                                               align: "end",
                                               display: true,
                                               color: 'blue'
                                           }
                                       }
                                   }}
                    />
                </>
            );
        }
        else if (chartData.message) {
            return <div>{chartData.message}</div>;
        }
    };

    render() {
        let gridTitleText = i18next.t("SubordinateList_GridTitle", {people_count: textUtils.pluralize_i18next(this.props.listSubForPO.rowsCount(), "peopleCountPostfix")});

        return (
            <>
                <PlaceholderWrapper placeholderId="10"
                                    title={<><i className='fa fa-filter'/> {i18next.t("WorkingHours")}</>}
                                    showSplitterLine={false}
                                    canCollapse={false}
                >
                    {this.renderFilter()}
                </PlaceholderWrapper>

                <PlaceholderWrapper placeholderId="20"
                                    title={<><i className='fa fa-bar-chart'/> </>}
                                    staticTitle={i18next.t("Diagram")}
                                    showSplitterLine={false}
                                    canCollapse={false}
                >
                    {this.renderChart()}
                </PlaceholderWrapper>

                <PlaceholderWrapper placeholderId="30"
                                    title={<><i className='fa fa-table'/> {gridTitleText}</>}
                                    staticTitle={i18next.t('SubordinateList_GridTitle')}
                                    showSplitterLine={false}
                                    canCollapse={false}
                >
                    <GridView dataItem={this.props.listSubForPO}
                              overrideVisibility={{IsChecked: false}}
                    />
                </PlaceholderWrapper>
            </>
        );
    }
}

WorkingHours.propTypes = {
    dispatch: PropTypes.func.isRequired,
    listSubForPO: PropTypes.object,
    listSubForPOParams: PropTypes.object,
    chartData: PropTypes.object,
    chartDataParams: PropTypes.object
};

WorkingHours.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        listSubForPO: state.workingHoursState.WorkingHours_ListSubForPO,
        listSubForPOParams: state.workingHoursState.WorkingHours_ListSubForPOParams,
        chartData: state.workingHoursState.WorkingHours_ChartData,
        chartDataParams: state.workingHoursState.WorkingHours_ChartDataParams
    }
}

export default connect(mapStateToProps)(WorkingHours);